import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="page">
      <h1 className="pageTitle">Not found</h1>
      <p className="muted">
        Страница не найдена. Вернуться на <Link to="/">главную</Link>.
      </p>
    </div>
  )
}

